import MailInput from './@mailInput/mailInput';
import PasswordInput from './@passwordInput/passwordInput';
import PhoneInput from './@phoneInput/phoneInput';
import PhoneVerification from './@phoneVerification/phoneVerification';
import showQuickRegisterDialog from './@quickRegisterDialog/quickRegisterDialog';

export {
    MailInput,
    PasswordInput,
    PhoneInput,
    PhoneVerification,
    showQuickRegisterDialog,
}
